import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Analytics } from "@vercel/analytics/react";
import Landing from "@/pages/Landing";
import Helm from "@/pages/Helm";
import HelmInbox from "@/pages/HelmInbox";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/the-helm" element={<Helm />} />
        <Route path="/the-helm/inbox" element={<HelmInbox />} />
      </Routes>
      <Analytics />
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid rgba(12,35,64,0.12)",
            color: "#0C2340",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
